import { useState } from 'react'
import { getErrorMessage } from '@/shared/lib'
import { useLoginAndProfileRepository } from '@/features/repositories/useLoginAndProfileRepository'
import { useNavigate } from 'react-router-dom'
import { useEPGCache } from '@/shared/cache/hooks/useEPGCache'
import { useEPGStore, useTVStore, useVODStore } from '@/shared/store'

export const usePinVerification = (goToHomeScreen?: boolean) => {
    const navigate = useNavigate()
    const [pin, setPin] = useState('')
    const [isPinValid, setIsPinValid] = useState(false)
    const [isPinError, setIsPinError] = useState('')
    const [shouldCheckPin, setShouldCheckPin] = useState<{
        shouldCheck: boolean
        id: string
        isKid?: boolean
        isEdit?: boolean
        isDelete?: boolean
        isSelect?: boolean
    }>({
        shouldCheck: false,
        id: '-1',
        isKid: true,
        isEdit: false,
        isDelete: false,
        isSelect: true,
    })
    const { checkParentControlPin } = useLoginAndProfileRepository()
    const handleInvalidPin = () => {
        setIsPinError('invalidPin')
        setIsPinValid(false)
        setPin('')
    }
    const { clearCache } = useEPGCache()

    const { clearEpgStore } = useEPGStore()
    const { clearTvStore } = useTVStore()
    const { setClearVod } = useVODStore()
    const clearStoreAndCache = () => {
        clearCache()
        setClearVod()
        clearEpgStore()
        clearTvStore()
    }

    const handleValidPin = async () => {
        setShouldCheckPin((prev) => ({
            ...prev,
            shouldCheck: false,
        }))
        setIsPinError('')
        setIsPinValid(true)
        setPin('')
        if (goToHomeScreen) {
            navigate('/')
            clearStoreAndCache()
        }
    }

    const handleCheckPin = async (pin: string, id: string) => {
        try {
            const status = await checkParentControlPin(Number(pin), id)
            !status ? handleValidPin() : handleInvalidPin()
        } catch (error) {
            getErrorMessage('Failed to check PIN:', error)
            setIsPinValid(false)
        }
    }

    return {
        pin,
        setPin,
        isPinValid,
        setIsPinValid,
        isPinError,
        setIsPinError,
        shouldCheckPin,
        setShouldCheckPin,
        handleCheckPin,
    }
}
